"use client";

import React from 'react';
import Link from "next/link"
import { usePathname } from "next/navigation";

interface ServicesMenuProps {
    menu?: Array<{
        name: string;
        url: string;
    }>;
}

const ServicesMenu: React.FC<ServicesMenuProps> = ({ menu = [] }) => {
    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    const getFullPath = (url: string) => `${isEn ? '/en' : ''}/services/${url}`;

    return (
        <div className="absolute bottom-[-24px] max-[992px]:max-w-[94%] max-[992px]:overflow-auto">
            <nav className="flex gap-4 text-sm uppercase max-[992px]:w-[672px] max-[992px]:overflow-auto">
                {menu.map((item, index) => {
                    const fullPath = getFullPath(item.url);
                    const isActive = pathname === item.url || pathname === fullPath;

                    return (
                        <Link key={index} href={fullPath} className={`${isActive ? "text-violet-500 font-bold border-white shadow-[0_4px_16px_0_#00000026]" : "text-violet-200 border-blue-violet-50 font-normal"} py-3.5 px-6 rounded-[32px] bg-white leading-[143%] leading-[111%] border-2 max-[576px]:py-[13px] max-[576px]:px-[16px] max-[576px]:text-[12px]`}>
                            {item.name}
                        </Link>
                    );
                })}
            </nav>
        </div>
    )
}

export default ServicesMenu;